function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "50",
  height: "50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.688 12.5c0-4.312 3.5-7.813 7.812-7.813h25c4.312 0 7.813 3.501 7.813 7.813v25c0 4.312-3.501 7.813-7.813 7.813h-25A7.816 7.816 0 014.687 37.5v-25zm3.125 1.563c0-3.45 2.8-6.25 6.25-6.25h21.874c3.45 0 6.25 2.8 6.25 6.25v21.874c0 3.45-2.8 6.25-6.25 6.25H14.064c-3.45 0-6.25-2.8-6.25-6.25V14.064zm17.187 0c-6.037 0-10.938 4.9-10.938 10.937 0 6.037 4.901 10.938 10.938 10.938 6.037 0 10.938-4.901 10.938-10.938 0-6.037-4.901-10.938-10.938-10.938zm0 3.124A7.816 7.816 0 0017.187 25c0 4.312 3.501 7.813 7.813 7.813 4.312 0 7.813-3.501 7.813-7.813 0-4.312-3.501-7.813-7.813-7.813zm11.719-6.25a2.345 2.345 0 10.001 4.69 2.345 2.345 0 00-.001-4.69z",
  fill: "#DD636E"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.365 4.688l3.125 3.125h10.448c3.449 0 6.25 2.8 6.25 6.25V24.51l3.124 3.125V12.5c0-4.312-3.5-7.813-7.812-7.813H22.365z",
  fill: "#8078BC"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.688 22.365V37.5c0 4.312 3.5 7.813 7.812 7.813h15.135l-3.125-3.126H14.062c-3.449 0-6.25-2.8-6.25-6.25V25.49l-3.125-3.125z",
  fill: "#FCB860"
})));